import { Patient } from '@/stores/store.types';

export const replacedPatientProfileHeader = ({
  patients,
  patientId,
  patient,
}: {
  patients?: Patient[];
  patientId?: string;
  patient?: Patient;
}) => {
  const { firstName, lastName } = patient
    ? patient
    : (patients?.find((p) => p._id === patientId) as Patient);

  return `Profil: ${firstName ?? ''} ${lastName ?? ''}`;
};

export const startsWithNumber = (str: string): boolean => {
  const regex = /^[0-9]/; // Regex to match the first character as a number (0-9)

  return regex.test(str);
};

export const formatTagLabel = (tagName: string): string => `# ${tagName}`;

export const getInitials = (fullName: string): string => {
  const parts = fullName.trim().split(' ').filter(Boolean);
  if (parts.length === 0) {
    return '';
  }
  if (parts.length === 1) {
    return parts[0][0]?.toUpperCase() ?? '';
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
